export default "__VITE_ASSET__2476a6c0__"